import { Checkbox, FormControlLabel, Stack } from '@mui/material';
import { toggleScanPrelabelVisibility, useScanPrelabelState } from '@scans/components/ScanPrelabel';
import {
  togglePrelabeledTrenchVisibility,
  usePrelabeledTrenchesState,
} from '@trenches/components/Prelabeled';

export const PrelabelsToggle = () => {
  const { show: showPrelabeledTrench } = usePrelabeledTrenchesState();
  const { show: showScanPrelabel } = useScanPrelabelState();

  return (
    <Stack gap={0.5}>
      <FormControlLabel
        control={
          <Checkbox checked={showPrelabeledTrench} onChange={togglePrelabeledTrenchVisibility} />
        }
        label="Trench prelabels"
      />
      <FormControlLabel
        control={<Checkbox checked={showScanPrelabel} onChange={toggleScanPrelabelVisibility} />}
        label="Prelabel v1"
      />
    </Stack>
  );
};
